import placeholderImg from "../assets/images/placeholder.png";
import projectvault_thumbnail from "../assets/images/projects/projectvault_thumbnail_dark.png";
import hourglass_thumbnail from "../assets/images/projects/hourglass_thumbnail.png";
import hourglass_1 from "../assets/images/projects/hourglass_1.png";
import hourglass_2 from "../assets/images/projects/hourglass_2.png";
import hourglass_3 from "../assets/images/projects/hourglass_3.png";
import hourglass_4 from "../assets/images/projects/hourglass_4.png";
import lmqt_thumbnail from "../assets/images/projects/lmqt_thumbnail.png";
import lmqt_1 from "../assets/images/projects/lmqt_1.png";
import lmqt_2 from "../assets/images/projects/lmqt_2.png";
import battle_ship_thumbnail from "../assets/images/projects/battleship_thumbnail.png";
import battle_ship_1 from "../assets/images/projects/battleship_1.png";
import battle_ship_2 from "../assets/images/projects/battleship_2.png";
import battle_ship_3 from "../assets/images/projects/battleship_3.png";
import battle_ship_4 from "../assets/images/projects/battleship_4.png";

const projectsData = [
  {
    id: 1,
    link: "/projects/hourglass",
    title: "Hourglass",
    descriptionShort:
      "An advanced time-tracking application designed for gatcha games events.",
    descriptionLong: [
      "Hourglass is a mobile application developed using React Native that helps users track time-limited events in gatcha games. It features customizable timers, notifications, and an intuitive user interface to ensure players never miss important in-game events.",
      "The app allows users to set multiple timers for different events, view countdowns, and receive alerts when events are about to start or end. It is designed to be lightweight and efficient, making it perfect for gamers on the go.",
      "By far my most complex application, it helped me to improve my skills in React Native and TypeScript development.",
    ],
    technologies: ["React Native", "TypeScript", "MySQL"],
    thumbnail: hourglass_thumbnail,
    images: [hourglass_1, hourglass_2, hourglass_3, hourglass_4],
    githubUrl: "https://github.com/Gaboruuu/Hourglass",
    liveUrl: "",
    featured: true,
    category: "mobile",
    keyFeatures: [
      "Customizable timers",
      "Push notifications",
      "User-friendly interface",
      "Time zone support",
      "Lightweight and efficient",
      "Offline functionality",
      "Event history tracking",
      "Theme customization",
      "Filtering and sorting of events",
      "Cross-platform compatibility (iOS and Android)",
    ],
  },
  {
    id: 2,
    link: "/projects/project-vault",
    title: "Project Vault",
    descriptionShort:
      "A early verion of a personal portfolio website to showcase my projects and skills.",
    descriptionLong: [
      "Project Vault is the early version of my personal portfolio website designed to showcase my projects, skills, and experience as a developer. The website features a clean and modern design, with easy navigation and responsive layout to ensure optimal viewing on all devices.",
      "Its initial purpose was to familiarize myself with React and Material-UI, while also providing a platform to present my work to potential employers and collaborators.",
      "It later only served as a foundation for the current website you are browsing right now.",
    ],
    technologies: ["React", "Material-UI", "JavaScript", "CSS"],
    thumbnail: projectvault_thumbnail,
    keyFeatures: [
      "Responsive design for all devices",
      "Clean and modern UI",
      "Project showcase",
    ],
    images: [placeholderImg, placeholderImg, placeholderImg, placeholderImg],
    githubUrl: "https://github.com/Gaboruuu/Project-Vault-Redesign",
    liveUrl: "",
    featured: true,
    category: "web",
  },

  {
    id: 3,
    link: "/projects/battle-ship",
    title: "Battle Ship",
    descriptionShort: "A classic Battleship game implemented in Python.",
    descriptionLong: [
      "This is a console-based implementation of the classic Battleship game using Python and Pygame",
      "The game features a graphical interface created with Pygame, allowing players to place their ships and make guesses on a grid.",
      "The player can customize the number and size of the ships as well as the board size",
      "The game is played agains a simple implemented AI.",
    ],
    technologies: ["Python", "Pygame"],
    thumbnail: battle_ship_thumbnail,
    images: [battle_ship_1, battle_ship_2, battle_ship_3, battle_ship_4],
    githubUrl: "https://github.com/Gaboruuu/Battle-Ship",
    liveUrl: "",
    featured: false,
    category: "python",
    keyFeatures: [
      "Single-player mode",
      "AI opponent",
      "Graphical interface",
      "Console interface",
      "Customizable game settings",
    ],
  },
  {
    id: 4,
    link: "/projects/local-movie-qt",
    title: "Local Movie QT",
    descriptionShort:
      "An C++/Qt application for managing a local movie collection.",
    descriptionLong: [
      "Local Movie QT is a desktop application developed using C++ and the Qt framework that simulate a simple local movie database manager.",
      "The app in devided into two main sections: admin and user section. The admin section allows users to add, edit, and delete movie entries, while the user section enables users to browse, add to watchlist, and rate movies as well as play the trailers.",
      "While the application is functional, it is primarily a learning project to enhance my skills in C++ and Qt development.",
    ],
    technologies: ["C++", "Qt"],
    thumbnail: lmqt_thumbnail,
    images: [lmqt_1, lmqt_2],
    githubUrl: "https://github.com/Gaboruuu/LocalMovieQT",
    liveUrl: "",
    featured: true,
    category: "QT",
    keyFeatures: [
      "Admin and user sections",
      "Movie management (add, edit, delete)",
      "Watchlist functionality",
      "Movie rating system",
      "Trailer playback",
      "Lightweight and efficient",
      "Export movie list to CSV and HTML",
      "Search and filter movies",
    ],
  },
  {
    id: 5,
    link: "/projects/interpreter",
    title: "Toy Language Interpreter",
    descriptionShort:
      "A fully functional interpreter for a custom toy programming language, built in Java with a JavaFX GUI.",
    descriptionLong: [
      "This interpreter executes programs written in a custom toy language, supporting variable declarations, arithmetic and logical expressions, conditional statements, loops, and heap memory management with garbage collection.",
      "The project implements a multi-threaded execution model using Java's ExecutorService, where programs can spawn new threads via a fork statement. Each thread has its own execution stack and symbol table, while sharing a common heap, output buffer, and lock table for mutual exclusion.",
      "Built with a clean MVC architecture, the application features a JavaFX GUI that lets users select from predefined programs and step through their execution, observing the state of the execution stack, symbol table, heap, and output in real time.",
    ],
    technologies: ["Java", "JavaFX", "MVC"],
    thumbnail: placeholderImg,
    images: [placeholderImg, placeholderImg],
    githubUrl: "https://github.com/Gaboruuu/Interpreter",
    liveUrl: "",
    featured: false,
    category: "desktop",
    keyFeatures: [
      "Custom toy language execution",
      "Multi-threaded program states via fork",
      "Heap memory with garbage collection",
      "Type checking before execution",
      "Lock/unlock synchronization primitives",
      "File I/O support",
      "Step-by-step execution in GUI",
      "Real-time state visualization",
      "18 statement types",
      "Program selector with multiple examples",
    ],
  },
];

export default projectsData;
